import { oneLine } from 'common-tags';

import { NextLink } from '@/atoms';

import { routes } from '@/lib/routes';
import { toArray } from '@/lib/utils';

import type { FunctionComponent } from 'react';
import type { TypeSellerBoxProps } from './types';

/**
 * SellerBox
 */
export const SellerBox: FunctionComponent<TypeSellerBoxProps> = ({
  className = '',
  seller,
  sellerLink,
  brand,
  deliveryDays,
  deliveryCosts,
  minFreeShipping,
  forceMobile = false,
  children,
  alwaysFree = false,
}: TypeSellerBoxProps) => (
  <div
    className={`box-border flex flex-col gap-4 border border-dashed border-primary-900 p-3 md:p-4 ${className}`}
  >
    <div className="flex flex-col gap-2">
      <div className="u-body u-body--s flex flex-row items-center gap-1 font-bold">
        <p className="text-primary-900">Vendido y enviado por</p>
        <NextLink href={sellerLink}>
          <a className="text-secondary-500">{seller.replace('&amp;', '&')}</a>
        </NextLink>
      </div>
      <div
        className={oneLine`u-body u-body--xs flex flex-col gap-y-[2px]
          ${
            !forceMobile
              ? 'md:flex-row md:divide-x-[1px] md:divide-primary-200 [&>p:nth-child(2)]:md:px-2 first:[&>p]:md:pr-2 last:[&>p]:md:pl-2 only:[&>p]:md:!p-0'
              : ''
          }
        `}
      >
        {deliveryDays && (
          <p>
            Entrega estim: <b>{deliveryDays}</b>
          </p>
        )}
        {deliveryCosts && !alwaysFree && (
          <p>
            Gastos de envío: <b>{deliveryCosts}</b>
          </p>
        )}
        {minFreeShipping && !alwaysFree && (
          <p>
            Envío gratuito a partir de <b>{minFreeShipping}</b>
          </p>
        )}
        {alwaysFree && (
          <p>
            <b>Envío gratuito</b>
          </p>
        )}
      </div>

      {brand && (
        <div className="u-body u-body--s flex flex-row items-center gap-1 font-bold">
          <p className="text-primary-900">Más productos de</p>
          <NextLink href={routes.brand(brand.slug)}>
            <a className="text-secondary-500">{brand.title}</a>
          </NextLink>
        </div>
      )}
    </div>

    {toArray(children).some(Boolean) && (
      <div className="flex flex-col gap-2">{children}</div>
    )}
  </div>
);

SellerBox.displayName = 'SellerBox';
